

import * as React from 'react';

const HelpPageFooterNotice = () => (
  <>
    <p>
      <b>
        For additional FAQ&apos;s and information, please click on link below:
      </b>
    </p>
    <p>
      <a href="https://helpdesk.cirium.com/s/topic/0TOJ5000000TNJeOAO/trip-center">
        Trip Center FAQs
      </a>
    </p>
  </>
);

export default HelpPageFooterNotice;
